import { useShowNotification } from '@inflearn/ds-react-next';

import { NEXT_PUBLIC_SHORT_URL_DOMAIN } from '../../appConfig';

type Params = {
  successMessage: string;
};

export function useCopyShortLink({ successMessage }: Params) {
  const { showNotification } = useShowNotification();

  const copyShortLink = ({ url, creatorId }: { url: string; creatorId?: number }) => {
    void navigator.clipboard.write([
      new ClipboardItem({
        'text/plain': (async () => {
          const controller = new AbortController();
          const timeoutId = setTimeout(() => controller.abort(), 3000);

          try {
            const shortLinkResponse = await fetch(`${NEXT_PUBLIC_SHORT_URL_DOMAIN}/new`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                url,
                creator_id: creatorId,
              }),
              signal: controller.signal,
            });

            const shortLinkJson = (await shortLinkResponse.json()) as { short_url: string };
            const shortLink = shortLinkJson.short_url;

            return new Blob([shortLink], { type: 'text/plain' });
          } catch {
            return new Blob([url], { type: 'text/plain' });
          } finally {
            clearTimeout(timeoutId);
            showNotification({
              title: successMessage,
              type: 'success',
            });
          }
        })(),
      }),
    ]);
  };

  return {
    copyShortLink,
  };
}
